import "core-js/modules/es6.regexp.match";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchSearch from '~/services/search';
export default {
  fetchContent(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        keyword,
        query
      } = _ref2;

      if (!keyword) {
        commit(types.SET_DESCRIPTION, {
          query: ''
        });
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        return;
      }

      const {
        productSearch
      } = yield fetchSearch(_this, keyword, query);

      if (!productSearch) {
        commit(types.SET_DESCRIPTION, {
          query: keyword
        });
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        return;
      }

      const {
        details,
        total,
        products
      } = productSearch;

      if (details.redirect) {
        const redirectUrl = "".concat(details.redirect_to);
        const currentQuery = keys(query).length ? "&".concat(stringify(query)) : '';

        if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
          _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
        } else {
          window.location.href = "".concat(redirectUrl).concat(currentQuery);
        }

        return;
      }

      commit(types.SET_DESCRIPTION, details);
      commit(types.SET_PRODUCTS, {
        products,
        total
      });
    })();
  },

  appendProducts(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        keyword,
        query
      } = _ref4;
      const {
        productSearch: {
          products
        }
      } = yield fetchSearch(_this2, keyword, query);
      commit(types.APPEND_PRODUCTS, products);
    })();
  },

  prependProducts(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref5;
      let {
        keyword,
        query
      } = _ref6;
      const {
        productSearch: {
          products
        }
      } = yield fetchSearch(_this3, keyword, query);
      commit(types.PREPEND_PRODUCTS, products);
    })();
  }

};